import pure from "./higher-order/pure";
import React from "react";

export default pure(function TablePaginationSpacer({ pageSize, totalItems }) {
  if (totalItems <= pageSize) {
    return null;
  }
  return <div className="game-table_cell game-table_cell--nav" />;
});
